import { useState, useEffect } from 'react'
import { bannerService } from '../lib/bannerService'
import type { Banner } from '../types/banner'

interface UseBannersOptions {
  position?: Banner['position']
  active?: boolean
  limit?: number
}

export const useBanners = (options: UseBannersOptions = {}) => {
  const { position, active = true, limit = 4 } = options
  const [banners, setBanners] = useState<Banner[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadBanners = async () => {
      try {
        setLoading(true)
         const allBanners = await bannerService.getBanners({ position, active })
         console.log('useBanners:', { position, active, count: allBanners.length, banners: allBanners })
        
        // Apply date filtering only in production (handled by service)
        // Shuffle randomly
        const shuffled = [...allBanners]
        for (let i = shuffled.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1))
          ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
        }
        
        setBanners(shuffled.slice(0, limit))
      } catch (error) {
        console.error('Error loading banners:', error)
        setBanners([])
      } finally {
        setLoading(false)
      }
    }

    loadBanners()
  }, [position, active, limit])

  return { banners, loading }
}